import { Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import type { ProcessTemplateTaskType } from '@econtractor/types';
import ProcessTasksTableBody from './ProcessTasksTableBody';
import type { ProcessTaskDuePatch } from './ProcessTaskDueDialog';

interface ProcessTasksTableProps {
    tasks: ProcessTemplateTaskType[];
    disabled?: boolean;
    /** Запущений процес: без колонки дій, зі статусом і відкриттям картки задачі. */
    launched?: boolean;
    onEdit: (task: ProcessTemplateTaskType) => void;
    onRemove: (task: ProcessTemplateTaskType) => void;
    onDueChange?: (dtId: number, patch: ProcessTaskDuePatch) => void;
    onOpenInstance?: (instanceId: number) => void;
}

const ProcessTasksTable = ({
    tasks,
    disabled,
    launched = false,
    onEdit,
    onRemove,
    onDueChange,
    onOpenInstance,
}: ProcessTasksTableProps) => {
    const { t } = useTranslation(['Tasks']);

    return (
        <div className="crm-table-wrap">
            <Table size="sm" className="ProcessTasksTable table-hover mb-0">
                <thead>
                    <tr className="bg-light">
                        <td className="head-name">{t('processDir.colTask')}</td>
                        <td className="head-trigger">{t('processDir.colDateTrigger')}</td>
                        {launched ? <td className="head-status">{t('fields.status')}</td> : null}
                        <td className="head-type">{t('processDir.colType')}</td>
                        <td className="head-username">{t('processDir.colExecutor')}</td>
                        {launched ? null : <td className="head-action" />}
                    </tr>
                </thead>
                <ProcessTasksTableBody
                    tasks={tasks}
                    disabled={disabled}
                    launched={launched}
                    onEdit={onEdit}
                    onRemove={onRemove}
                    onDueChange={onDueChange}
                    onOpenInstance={onOpenInstance}
                />
            </Table>
        </div>
    );
};

export default ProcessTasksTable;
